export default __webpack_public_path__ + "static/media/Harsh Deshwal.57dcaadf.png";